import { render, staticRenderFns } from "./Benutzer.vue?vue&type=template&id=884f503a&scoped=true"
import script from "./Benutzer.vue?vue&type=script&lang=js"
export * from "./Benutzer.vue?vue&type=script&lang=js"
import style0 from "./Benutzer.vue?vue&type=style&index=0&id=884f503a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884f503a",
  null
  
)

export default component.exports